import validate from 'validate.js';
import { gsap, TweenLite, Power1 } from "gsap";
import { AsYouType } from 'libphonenumber-js';
import { parsePhoneNumberFromString as parseMin } from 'libphonenumber-js/max'

document.addEventListener('DOMContentLoaded',function() {

    const el = document.getElementById('subscribe');

    const init = function() {
        const step = document.getElementsByClassName('js-step');

        const login_btn = document.getElementsByClassName('js-login'),
              login_form = document.getElementById('s_login'),
              login_constraints = {
                 email: {
                    presence: { message: "Pole nie może być puste" },
                    email: { message: 'Adres nieprawidłowy' }
                 }
              };

        const register_form = document.getElementById('s_register'),
              register_constraints = {
                 email: {
                    presence: { message: "Pole nie może być puste" },
                    email: { message: 'Adres nieprawidłowy' }
                 },
                 name: {
                    presence: { message: "Pole nie może być puste" },
                    length: {
                        maximum: 255,
                        minimum: 3,
                        message: 'Min. 3 znaki'
                    },
                    format: {
                        pattern: "[a-ząćęłńóśźżĄĆĘŁŃÓŚŹŻ0-9 ,.'-]+",
                        flags: "i",
                        message: "Tylko znaki a-z i 0-9"
                    }
                },
                tel: {
                    presence: { message: "Pole nie może być puste" },
                    telCheck: "Podaj poprawny numer"
                },
                zgodaNaPrzetwarzanie: {
                    presence: { message: "Pole wymagane" },
                    inclusion: {
                    within: [true],
                        message: "^You need to check the checkbox"
                    }
                 },
                  zgodaNaWysylanie: {
                    presence: { message: "Pole wymagane" },
                    inclusion: {
                    within: [true],
                        message: "^You need to check the checkbox"
                    }
                 },
                  zgodaNaWysylanie2: {
                    presence: { message: "Pole wymagane" },
                    inclusion: {
                    within: [true],
                        message: "^You need to check the checkbox"
                    }
                 },
                  zgodaNaOtrzymywanie: {
                    presence: { message: "Pole wymagane" },
                    inclusion: {
                    within: [true],
                        message: "^You need to check the checkbox"
                    }
                 },
              };

        const registered_form = document.getElementById('s_registered'),
              registered_constraints = {
                 email: {
                    presence: { message: "Pole nie może być puste" },
                    email: { message: 'Adres nieprawidłowy' }
                 }
              };


        const buttons = {
            login: function() {
                for (let i = 0; i < login_btn.length; i++) {
                    login_btn[i].addEventListener('click', function(e) {
                        steps.hide();
                        login_form.classList.add('is-active');
                        steps.show();
                        e.preventDefault() ? e.preventDefault() : e.preventDefault = false;
                    });
                }
            },

            showArticle: function() {
                document.getElementsByClassName('js-showArticle')[0].addEventListener('click', function(e) {
                    location.reload();
                    e.preventDefault() ? e.preventDefault() : e.preventDefault = false;
                })
            },

            register: function() {
                let register_btn = document.getElementsByClassName('js-register');

                const action = function(e) {
                    steps.hide();
                    register_form.classList.add('is-active');
                    steps.show();
                    e.preventDefault() ? e.preventDefault() : e.preventDefault = false;
                }

                for (let i = 0; i < register_btn.length; i++) {
                    register_btn[i].removeEventListener('click', action);
                    register_btn[i].addEventListener('click', action);
                }
            }

        }

        const thanks = document.getElementById('s_thanks');

        const payload = {
            formToJSON: (elements) =>
              [].reduce.call(
                elements,
                (data, element) => {
                    if (element.type === 'radio') {
                        if (element.checked) {
                            data[element.name] = element.value;
                        }
                    } else {
                        if (element.name == 'phone') {
                            data[element.name] = element.value.replaceAll(" ", "");
                        } else {
                            data[element.name] = element.value;
                        }
                    }
                  return data;
                },
                {},
            ),

            getJSON: function(form, url, callback) {
                let xhr = new XMLHttpRequest();
                xhr.open('POST', url, true);
                xhr.responseType = 'json';
                xhr.onload = function() {
                    let status = xhr.status;
                    if (status === 200) {
                        callback(null, xhr.response);
                    } else {
                        callback(status, xhr.response);
                    }

                    preloader.hide(form);
                };

                xhr.addEventListener('error', function() {
                });

                xhr.open('post', url, true);
                xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
                xhr.send(JSON.stringify(payload.formToJSON(form.elements)));
                if (login_form.getElementsByClassName('js-message-server')[0]) {
                    login_form.getElementsByClassName('js-message-server')[0].removeAttribute('style');
                }
                //console.log(JSON.stringify(payload.formToJSON(form.elements)));
            }
        }

        const steps = {
            hide: function() {
                for (let i = 0; i < step.length; i++) {
                    if (step[i].classList.contains('is-active')) {
                        TweenLite.to(step[i], 0.4, {
                            opacity: 0
                        })
                        step[i].classList.remove('is-active');
                        login_form.getElementsByClassName('js-message-server')[0].removeAttribute('style');
                    }
                }
            },
            show: function() {
                for (let i = 0; i < step.length; i++) {
                    if (step[i].classList.contains('is-active')) {
                        TweenLite.set(step[i], {
                            opacity: 1
                        })
                        TweenLite.from(step[i], 0.4, {
                            opacity: 0
                        })
                    }
                }
            }
        }

        const subscribe = {
            login: function(err, data) {
                const parseData = function(err, data) {
                    if (err === null) {
                        if (data.result === false) {
                            login_form.getElementsByClassName('js-message-server')[0].style.display = 'block';
                            login_form.getElementsByClassName('js-message-server')[0].innerHTML = data.message;
                            document.getElementsByClassName('js-register').length > 0 ? buttons.register() : false;
                        } else {
                            location.reload();
                        }

                        if (data.success === false) {
                            login_form.getElementsByClassName('js-message-server')[0].style.display = 'block';
                            login_form.getElementsByClassName('js-message-server')[0].innerHTML = data.message;
                        }
                    } else {
                        if (err === 500) {
                            console.log(err);
                        }
                    }
                }

                preloader.show(login_form);
                payload.getJSON(login_form, login_form.getAttribute('action'), parseData)
            },

            register: function(err, data) {
                const parseData = function(err, data) {
                    if (err === null) {

                        console.log(data);

                        if (data.result === false) {
                            // user exist
                            //steps.hide();
                            //registered_form.classList.add('is-active');
                            //steps.show();

                            register_form.getElementsByClassName('js-message-server')[0].style.display = 'block';
                            register_form.getElementsByClassName('js-message-server')[0].innerHTML = data.message;

                        } else {
                            // if email exist

                            console.clear();
                            console.log(data);

                            if (data.exist === true) {
                                steps.hide();
                                registered_form.classList.add('is-active');
                                steps.show();
                            } else {
                                steps.hide();
                                thanks.classList.add('is-active');
                                steps.show();
                            }
                        }

                        if (data.success === false) {
                            login_form.getElementsByClassName('js-message-server')[0].style.display = 'block';
                            login_form.getElementsByClassName('js-message-server')[0].innerHTML = data.message;
                        }
                    } else {
                        if (err === 500) {
                            console.log(err);
                        }
                    }
                }

                preloader.show(register_form);
                payload.getJSON(register_form, register_form.getAttribute('action'), parseData)
            },

            registered: function(err, data) {
                const parseData = function(err, data) {
                    if (err === null) {
                        if (data.result === false) {
                            registered_form.getElementsByClassName('js-message-server')[0].style.display = 'block';
                            registered_form.getElementsByClassName('js-message-server')[0].innerHTML = data.message;

                        } else {
                            location.reload();
                        }

                        if (data.success === false) {
                            registered_form.getElementsByClassName('js-message-server')[0].style.display = 'block';
                            registered_form.getElementsByClassName('js-message-server')[0].innerHTML = data.message;
                        }
                    } else {
                        if (err === 500) {
                            console.log(err);
                        }
                    }
                }

                preloader.show(registered_form);
                payload.getJSON(registered_form, registered_form.getAttribute('action'), parseData)
            },
        }

        const val = function(el, constraints, callback) {

            const form = el;

            form.addEventListener("submit", function(ev) {
                ev.preventDefault();
                handleFormSubmit(form);
            });

            const inputs = form.querySelectorAll("input, textarea, select");

            for (let i = 0; i < inputs.length; ++i) {
                inputs.item(i).addEventListener("change", function(ev) {
                    const errors = validate(form, constraints, { fullMessages: false }) || {};
                    showErrorsForInput(this, errors[this.name])
                });
            }

            function handleFormSubmit(form, input) {
                const errors = validate(form, constraints, { fullMessages: false });
                showErrors(form, errors || {});
                if (!errors) {
                    showSuccess();
                } else {
                    // console.log(errors);
                }
            };

            function showErrors(form, errors) {
                _.each(form.querySelectorAll("[required]"), function(input) {
                    showErrorsForInput(input, errors && errors[input.name]);
                });

                window.runScroll('#subscribe', -500);

            };

            function showErrorsForInput(input, errors) {
                const formGroup = closestParent(input.parentNode, "form-row"),
                      messages = formGroup.querySelector(".js-message");
                resetFormGroup(formGroup);
                if (errors) {
                    formGroup.classList.add("has-error");
                    _.each(errors, function(error) {
                        if (messages) {
                            messages.style.display = 'block';
                            addError(messages, error);

/*
                            for (let i = 0; i < step.length; i++) {
                                if (step[i].classList.contains('is-active')) {
                                    TweenLite.to(step[i], 0.4, {
                                        opacity: 0
                                    })
                                }
                            }
*/
                        }
                    });
                } else {
                    formGroup.classList.add("has-success");
                }
            };

            function closestParent(child, className) {
                if (!child || child == document) {
                    return null;
                }
                if (child.classList.contains(className)) {
                    return child;
                } else {
                    return closestParent(child.parentNode, className);
                }
            };

            function resetFormGroup(formGroup) {
                // Remove the success and error classes
                formGroup.classList.remove("has-error");
                formGroup.classList.remove("has-success");
                if (formGroup.getElementsByClassName('js-message')[0]) {
                    formGroup.getElementsByClassName('js-message')[0].style.display = 'none';
                }
                _.each(formGroup.querySelectorAll(".help-block.error"), function(el) {
                    el.parentNode.removeChild(el);
                });
            }

            function addError(messages, error) {
                const block = document.createElement("p");
                block.classList.add("help-block");
                block.classList.add("error");
                block.innerText = error;
                messages.appendChild(block);
            }

            function showSuccess() {
                callback();
            }
        };

        const preloader = {
            hide: function(form) {
                form.querySelector('button').style.display = 'inline-flex';
                form.querySelector('.lds-ripple').style.display = 'none';
            },
            show: function(form) {
                form.querySelector('button').style.display = 'none';
                form.querySelector('.lds-ripple').style.display = 'inline-flex';
            }
        }

        const tooltip = function() {
            const tt = document.getElementsByClassName('js-subscribeTooltip')[0],
                  btn_open = document.getElementsByClassName('js-openSubscribeTooltip')[0],
                  btn_close = document.getElementsByClassName('js-closeSubscribeTooltip')[0];

            btn_open.addEventListener('click', function() {
                if (tt.classList.contains('is-open')) {
                    tt.classList.remove('is-open')
                } else {
                    tt.classList.add('is-open');
                }
            })

            btn_close.addEventListener('click', function() {
                tt.classList.remove('is-open')
            })
        }

        const backToIntro = function() {
            const el = document.getElementsByClassName('js-backToIntro')[0];

            el.addEventListener('click', function() {
                steps.hide();
                document.getElementById('s_intro').classList.add('is-active');
                steps.show();
            });
        }


        const toggleButton = function() {
            const toggleCheckbox = document.getElementsByClassName('js-toggle')[0];

            function action(e) {
                const checkboxes = register_form.querySelectorAll('input[type="checkbox"]');
                for (let i = 0; i < checkboxes.length; i++) {
                    checkboxes[i].checked = e.currentTarget.checked;
                }
            }

            toggleCheckbox ? toggleCheckbox.addEventListener('click', action) : false;
        }();

        const telFormat = function() {
            let inputs = document.getElementsByTagName('input');

            for(let i = 0; i < inputs.length; i++) {
                if(inputs[i].type.toLowerCase() == 'tel') {
                    inputs[i].addEventListener("keyup", event => {
                        let val_old = inputs[i].value,
                            val_new = new AsYouType('PL').input(inputs[i].value);
                        inputs[i].value = val_new;
                    });
                }
            }
        }();

        // init


        // Custom Validate for telephone
        validate.validators.telCheck = function(value, options, key, attributes) {

            if (value) {
                let phoneNumber = parseMin(value, 'PL');

                if (phoneNumber.isValid()) {
                    return;
                } else {
                    return 'Podaj poprawny numer';
                }
            }
        };

        steps.show();

        login_form ? val(login_form, login_constraints, subscribe.login) : false;
        register_form ? val(register_form, register_constraints, subscribe.register) : false;
        registered_form ? val(registered_form, registered_constraints, subscribe.registered) : false;

        login_btn.length > 0 ? buttons.login() : false;
        document.getElementsByClassName('js-backToIntro')[0] ? backToIntro() : false;
        document.getElementsByClassName('js-openSubscribeTooltip')[0] ? tooltip() : false;
        document.getElementsByClassName('js-register').length > 0 ? buttons.register() : false;
        document.getElementsByClassName('js-showArticle')[0] ? buttons.showArticle() : false;
    };

    el ? init() : false;

}, false);
